import React, { useContext, useEffect, useState } from 'react'
import PrizeWheel from './PrizeWheel'
import { useParams } from 'react-router-dom';
import Context from '../../app_context/Context';
import { get_point_balance_store_by_cust_code, get_reward_history, get_reward_wheel_game_tr } from '../../page_action/wheel_game_play';
import BackgroundMusic from './BackgroundMusic'; // เพิ่ม import
import Lottie from "lottie-react";
import LoadingAnime from "./Animation - 1737607924764.json";

export default function Page() {
    const { userData, set_site_title } = useContext(Context);
    const { CUSTCODE } = useParams()
    const [custPointblance, setCustPointblance] = useState(null)
    const [initialPrizes, setInitialPrizes] = useState(null)
    const [dataRewardHistory, setDataRewardHistory] = useState([])

    useEffect(() => {
        document.body.style.removeProperty('margin-right');
        document.body.style.removeProperty('padding-right');
        document.body.style.removeProperty('overflow');
    })

    useEffect(() => {
        set_site_title("MK-Rewards | เล่นเกมส์วงล้อ")
    }, [])

    useEffect(() => {
        if (userData) {
            let form = {
                CUSTCODE: CUSTCODE,
                LINE_TOKEN: userData.data_main.LINE_TOKEN,
                MOBILE: userData.data_main.MOBILE,
                LINE_NAME: userData.data_main.LINE_NAME,
            }
            // console.log(form)
            get_point_balance(true)
            get_item_spin(setInitialPrizes, true)
            get_reward_history_custcode()
        }
    }, [userData])

    const get_point_balance = async (isLoad) => {
        let form = {
            CUSTCODE: CUSTCODE,
            LINE_TOKEN: userData.data_main.LINE_TOKEN,
            MOBILE: userData.data_main.MOBILE,
            LINE_NAME: userData.data_main.LINE_NAME,
        }
        return await get_point_balance_store_by_cust_code(form, setCustPointblance, isLoad,)
    }

    const get_item_spin = async (setPrizes, isLoad) => {
        return await get_reward_wheel_game_tr({}, setPrizes, isLoad)
    }

    const get_reward_history_custcode = async (isLoad) => {
        let form = {
            CUSTCODE: CUSTCODE,
        }
        return await get_reward_history(form, setDataRewardHistory, isLoad)
    }


    return (
        userData ? <div className=''>
            {/* <BackgroundMusic audioUrl="https://www.mkmedical.online:444/image_wheel_game/Mingle%20Game%20Song.mp3" /> */}
            {initialPrizes ? <PrizeWheel
                userData={userData}
                custPointblance={custPointblance}
                CUSTCODE={CUSTCODE}
                initialPrizes={initialPrizes}
                get_item_spin={get_item_spin}
                get_point_balance={get_point_balance}
                dataRewardHistory={dataRewardHistory}
                get_reward_history_custcode={get_reward_history_custcode}
            />
                :
                <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 "
                    style={{
                        backgroundImage: 'url("https://www.mkmedical.online:444/image_wheel_game/chinese-newyear.png")',
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                    }}>
                    <div className="w-64 h-64"> {/* หรือขนาดที่ต้องการ เช่น w-32 h-32 */}
                        <Lottie
                            animationData={LoadingAnime}
                            loop={true}
                            style={{ width: '100%', height: '100%' }}
                        />
                    </div>
                </div>}
        </div > : <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 "
            style={{
                backgroundImage: 'url("https://www.mkmedical.online:444/image_wheel_game/chinese-newyear.png")',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            }}>
            <div className="w-64 h-64"> {/* หรือขนาดที่ต้องการ เช่น w-32 h-32 */}
                <Lottie
                    animationData={LoadingAnime}
                    loop={true}
                    style={{ width: '100%', height: '100%' }}
                />
            </div>
        </div>
    )
}
